class RecuperaSenha {
    constructor() {
        this.chave = null
        this.senha = null
    }
}
export default RecuperaSenha;